
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vacancy",
      function () {
        return require("private-next-pages/vacancy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vacancy"])
      });
    }
  